import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";
import { Redirect } from "react-router-dom";
import moment from "moment";
import { formatPhoneNumber } from "utils/formatPhoneNumber";
import { cleanDateFormat } from "utils/cleanDateFormat";
import { replaceHashValues } from "utils/replaceHashValues";
import { checkAMLob } from "utils/checkAMLob";
import { media } from "utils/style";
import Container from "common-components/Container";
import Button from "common-components/Buttons";
import Header from "common-components/Header";
import { checkNestedObject } from "utils/checkNestedObject";
import { setBreadcrumbList } from "common-components/BreadCrumbs/actions";
import { setA11yContent } from "../../NavigationHelper/actions";
import { handleModalState } from "common-components/Modal/actions/handleModalState";
import {clearErrors, fetchRequestHistory} from "../../DownloadAndDelete/actions";
import RectangleLoader from "common-components/RectangleLoader";
import CancelRequestModal from "../../DownloadAndDelete/DownloadStatus/CancelRequestModal/CancelRequestModal";
import {cancelAppeal} from "./actions/cancelAppeal";

class FormerAndGuestAppealStatus extends Component  {
  
  state = {
    showCancelModal: false
  };

  componentDidMount() {


    this.props.fetchRequestHistory();
    

    if (checkNestedObject(this.props, "pageContent", "sections", [2], ["appeal"], [2], "sc_pagetitle")) {
      this.props.setA11yContent("Appeal Status", this.props.pageContent.sections[2]["appeal"][2].sc_pagetitle);
    }

    if (checkNestedObject(this.props, "pageContent", "breadCrumbs", "landingPage")) {
      const { landingPage, requestStatus } = this.props.pageContent.breadCrumbs;

      this.props.setBreadcrumbList([
        { label: landingPage, path: "/privacy/secure/your-data" },
        { label: requestStatus, path: "/privacy/secure/appeal-status" }
      ]);
    }

  }

  formatDate = date => {
    return moment(date)
      .format("MMM DD, YYYY")
      .toString();
  };

  showConfirmationModal = () => {
    this.props.handleModalState();
    this.props.clearErrors();
    this.setState({ showCancelModal: true });

  };

  checkNotificationMethod = () => {
    let notificationMethod = "";
    const { accountEmail, accountOttEmail, wlnMdn } = window.reactGlobals;
    //const { mtnList } = this.props.location.state.historyInfo;
    let mtnList = [];
    if (checkNestedObject(this.props, "location", "state", "historyInfo")) {    
      mtnList = this.props.location.state.historyInfo.mtnList;
    }
    else if (checkNestedObject(this.props, "elementsData", [0])) {    
      mtnList = this.props.elementsData[0].mtnList;
    }


    if (checkAMLob() === "ott" && accountOttEmail) {
      notificationMethod = accountOttEmail;
    } else if (checkAMLob() === "vzt") {
      if (accountEmail && wlnMdn) {
        notificationMethod = `${accountEmail}, and ${formatPhoneNumber(wlnMdn)}`;
      } else if (accountEmail) {
        notificationMethod = accountEmail;
      } else {
        notificationMethod = formatPhoneNumber(wlnMdn);
      }
    } else {
      if (mtnList.length && accountEmail) {
        notificationMethod = `${accountEmail}, and ${formatPhoneNumber(mtnList[0])}`;
      } else if (mtnList.length) {
        notificationMethod = formatPhoneNumber(mtnList[0]);
      } else {
        notificationMethod = accountEmail;
      }
    }
    return notificationMethod;
  };

  handleCancelAppealClick = type => {
    this.props.handleModalState(false);
    this.setState({ showCancelModal: false });

    let appealId = "";
    let uniqueTxnId = "";
    //if this page is called from history.
    if (checkNestedObject(this.props, "location", "state", "historyInfo") && checkNestedObject(this.props, "location", "state", "theActualRecordOnWhichTheAppealApplied", [0])) {
      appealId =  this.props.location.state.historyInfo.appealId;
      uniqueTxnId =  this.props.location.state.theActualRecordOnWhichTheAppealApplied[0].uniqueTxnId;
    }
    else if (checkNestedObject(this.props, "elementsData", [0])) {    
      //if this page is called from banner click.
      appealId =  this.props.elementsData[0].appealId;
      const uniqueTxnIdOfAppeal = this.props.elementsData[0].uniqueTxnId;
      const theActualRecordOnWhichTheAppealApplied = this.props.elementsData.filter((item) => item.appealId.endsWith(uniqueTxnIdOfAppeal) && item.status === "APPEAL_PENDING");
      uniqueTxnId = theActualRecordOnWhichTheAppealApplied && theActualRecordOnWhichTheAppealApplied.length > 0 ? theActualRecordOnWhichTheAppealApplied[0].uniqueTxnId : "";
    }
    
    if(uniqueTxnId && appealId) {
      const payload = {
        uniqueTxnId,
        appealId
      };
  
      this.props.cancelAppeal(payload).then(() => {
        if (!this.props.error) {
          this.props.history.replace("/privacy/secure/your-data");        
        }
      });  

    }
 
  };


  render() {

    if (this.props.loading) {
      return <RectangleLoader id={"formerLoader"}/>;
    }

    if (!this.props.pageContent) {
      return <Redirect to="/privacy/secure/your-data" />;
    }

    
    if (!checkNestedObject(this.props, "pageContent", "sections", [2], "appeal", [2])) {
        return <Redirect to="/privacy/secure/your-data" />;
    }
    if (!checkNestedObject(this.props, "pageContent", "sections", [2], "appeal", [3])) {
      return <Redirect to="/privacy/secure/your-data" />;
    }

    const appealStatusPageContent = this.props.pageContent.sections[2]["appeal"][2];
    const appealCancelModalContent  = this.props.pageContent.sections[2]["appeal"][3];

    let dateOfRequest = "";
    let theActualRecordOnWhichTheAppealApplied = [];
    if (checkNestedObject(this.props, "location", "state", "historyInfo") && checkNestedObject(this.props, "location", "state", "theActualRecordOnWhichTheAppealApplied")) {
      dateOfRequest = this.props.location.state.historyInfo.dateOfRequest;
      theActualRecordOnWhichTheAppealApplied = this.props.location.state.theActualRecordOnWhichTheAppealApplied;
    }
    else if (checkNestedObject(this.props, "elementsData", [0])) {    
      dateOfRequest = this.props.elementsData[0].dateOfRequest;
      const uniqueTxnIdOfAppeal = this.props.elementsData[0].uniqueTxnId;
      theActualRecordOnWhichTheAppealApplied = this.props.elementsData.filter((item) => item.appealId === uniqueTxnIdOfAppeal && item.status === "APPEAL_PENDING");
    }


    return (
      <Fragment>
        <Container>
          <Header style={{ maxWidth: "294px", marginBottom:"28px" }}>{appealStatusPageContent.section_title}</Header>
          <Div>
            <p>
              {dateOfRequest && dateOfRequest.trim().length > 0 && convertStringToElements(
                replaceHashValues(appealStatusPageContent.section_description, {
                  dateOfRequestAppeal: this.formatDate(cleanDateFormat(dateOfRequest)),
                  dateOfRequestDownloadDenied: theActualRecordOnWhichTheAppealApplied && theActualRecordOnWhichTheAppealApplied.length > 0 ? this.formatDate(cleanDateFormat(theActualRecordOnWhichTheAppealApplied[0].dateOfRequest)) : ""
                })
              )}
            </p>
            <p>
              {convertStringToElements(
                replaceHashValues(appealStatusPageContent.Category[0].category_description, {
                  notificationMethod: this.checkNotificationMethod()
                })
              )}
            </p>
          </Div>

          <Button onClick={this.showConfirmationModal} background={appealStatusPageContent.buttons[0].type}>
            {appealStatusPageContent.buttons[0].text}
          </Button>

          {this.props.showModal && this.state.showCancelModal && (
            <CancelRequestModal
              modalContent={appealCancelModalContent}
              handleClick={this.handleCancelAppealClick}
              handleCancelClick={() => this.props.handleModalState(false)}
              dateOfRequest={this.formatDate(cleanDateFormat(dateOfRequest))}
              loading={this.props.loading}
            />
          )}

        </Container>
      </Fragment>
    )
  }
}

const mapStateToProps = ({
  pageContent,
  modalState,
  requestHistory: { elementsData},
  loadingAndErrorState: { loading, error },
}) => ({
  pageContent,
  showModal: modalState.showModal,
  elementsData,
  loading,
  error  
});


export default connect(
  mapStateToProps,
  {handleModalState, clearErrors, setA11yContent, setBreadcrumbList, cancelAppeal, fetchRequestHistory }
)(FormerAndGuestAppealStatus);


const Div = styled.div`
  max-width: 385px;
  margin-bottom: 50px;
  p {
    margin: 15px 0;
  }

  ${media.tablet`
    margin: 0 auto;
  `}
`;

/*
const Div = styled.div`
  margin-bottom: 55px;
  p {
    margin: 15px 0;
  }
`;*/
